import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind-aware className merger — the one every shadcn component uses. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
